// @ts-nocheck


import React from 'react';

import TripListByType from './../components/TripListByType';
import { tripTypeEnum } from './../../../lib/enum';





const ArchiveTripList = ({ location = {} }) =>
<TripListByType location={location} tripType={tripTypeEnum.archive} />;


export default ArchiveTripList;